import { gql } from 'graphql-tag';

export const GET_ACCOUNT_PAYABLE_SUPPLIERS_LIST_QUERY = gql`
  query Id8871adc09a225fe370e05877c0354533(
    $companyId: ID!
    $after: ID
    $filter: AccountPayableFilter!
    $supplierFilter: SupplierFilter
    $includeDefaultFor: Boolean!
  ) {
    __typename
  }
`;
